import React, { useState, useEffect } from 'react'
import './Submission.css'
import { getDeadlineStatus } from '../../utils/deadlineChecker'


export default function Submission() {
    const [deadlineStatus, setDeadlineStatus] = useState({ isOpen: true, message: null });

    useEffect(() => {
        const status = getDeadlineStatus();
        setDeadlineStatus(status);
    }, []);

    const links = {
        ksrDatavizon: "https://www.linkedin.com/company/datavizon/",
        kiran: "https://www.linkedin.com/in/kiran-kumar-ksr-81a172323/",
        sontosh: "https://www.linkedin.com/in/santosh-j-44b203216/",
        mahesh: "https://www.linkedin.com/in/mahesh-desireddy-06323252/",
        group: "https://www.linkedin.com/groups/14516967/"
    }

    function naviagetLinkedin(link) {
        window.open(link, '_blank')
    }

    const handleSubmitClick = () => {
        const currentStatus = getDeadlineStatus();
        if (!currentStatus.isOpen) {
            alert(currentStatus.message);
            return;
        }
        window.open('https://forms.cloud.microsoft/r/PgF6F9cqvg', "_blank");
    }


    return (
        <div>
            <p className='DatasetHeading'>SUBMISSION GUIDELINES</p>
            <p className='submissionSubHeading'>To successfully submit your entry, please follow these steps:</p>

            <div className='allGuidelines'>
                <div className='eachSubmission' style={{ backgroundColor: "rgba(176, 237, 237, 0.5)" }}>
                    <img src='/submission_pic1.png' alt='submission' className='submissionImage'></img>
                    <div className='submissionContent'>
                        <p className='submissionContentHeading'>Follow Us on LinkedIn</p>
                        <p className='submissionContentDesc'>Ensure you are following <span className='strong' onClick={() => naviagetLinkedin(links.ksrDatavizon)}>@KSR DataVizon</span>  on LinkedIn to stay updated with the latest
                            announcements and resources.</p>
                    </div>
                </div>

                <div className='eachSubmission' style={{ backgroundColor: "white" }}>
                    <img src='/submission_pic2.png' alt='submission' className='submissionImage'></img>
                    <div className='submissionContent'>
                        <p className='submissionContentHeading'>Share Your Work</p>
                        <p className='submissionContentDesc'>Publish a post on your LinkedIn profile featuring your video presentation or an image of your
                            report. Be sure to tag <span className='strong' onClick={() => naviagetLinkedin(links.ksrDatavizon)}>@KSR Datavizon</span>,
                            <span className='strong' onClick={() => naviagetLinkedin(links.sontosh)}> @Santosh J</span>,
                            <span className='strong' onClick={() => naviagetLinkedin(links.mahesh)}> @Mahesh Desireddy</span> and
                            <span className='strong' onClick={() => naviagetLinkedin(links.kiran)}> @Kiran Kumar KSR</span> in your post to acknowledge their
                            support and guidance.</p>
                    </div>
                </div>

                <div className='eachSubmission' style={{ backgroundColor: "rgba(176, 237, 237, 0.5)" }}>
                    <img src='/submission_pic3.png' alt='submission' className='submissionImage'></img>
                    <div className='submissionContent'>
                        <p className='submissionContentHeading'>Community Engagement</p>
                        <p className='submissionContentDesc'>Additionally, post your report in the
                            <span className='strong' onClick={() => naviagetLinkedin(links.group)}> KSR Datavizon Data Challenges LinkedIn Community
                                Group</span>. This step ensures your work is visible to a broader community of peers and mentors.</p>
                    </div>
                </div>

                <div className='eachSubmission' style={{ backgroundColor: "white" }}>
                    <img src='/submission_pic4.png' alt='submission' className='submissionImage'></img>
                    <div className='submissionContent'>
                        <p className='submissionContentHeading'>Email Submission</p>
                        <p className='submissionContentDesc'>Send your .pbix file to <a href="mailto: hackathons@datavizon.com" className='strong' style={{ wordBreak: "break-all", textDecoration: "none" }}> hackathons@datavizon.com</a>. This will enable us to provide you with
                            personalized feedback on your submission.</p>
                    </div>
                </div>

                <div className='eachSubmission' style={{ backgroundColor: "rgba(176, 237, 237, 0.5)" }}>
                    <img src='/submission_pic4.png' alt='submission' className='submissionImage'></img>
                    <div className='submissionContent'>
                        <p className='submissionContentHeading'>Join in our WhatsApp Group</p>
                        <p className='submissionContentDesc'>Make sure join in <a href="https://chat.whatsapp.com/KZcwPOhYTy92PZEGXqVqPH" target="_blank" className='strong' style={{ wordBreak: "break-all", textDecoration: "none" }}>  WhatsApp group </a>for regular updates and you can ask your questions
                            in that group.</p>
                    </div>
                </div>

                <div className='eachSubmission' style={{ backgroundColor: "white" }}>
                    <img src='/submission_pic4.png' alt='submission' className='submissionImage'></img>
                    <div className='submissionContent'>
                        <p className='submissionContentHeading'>Final Submission</p>
                        <p className='submissionContentDesc'>Complete all the above steps and navigate to  <a href="https://forms.cloud.microsoft/r/PgF6F9cqvg" target="_blank" className='strong' style={{ wordBreak: "break-all", textDecoration: "none" }}> KSR Datavizon Hackathon Form</a> by clicking  <span style={{ cursor: "default" }} className='strong'>Submit your entry </span>
                            button and fill the required details for successful submission.</p>
                    </div>
                </div>

                {!deadlineStatus.isOpen && (
                    <div className='deadlineMessage' style={{
                        backgroundColor: '#ffebee',
                        border: '2px solid #f44336',
                        borderRadius: '8px',
                        padding: '15px',
                        margin: '20px 0',
                        textAlign: 'center',
                        color: '#d32f2f',
                        fontWeight: 'bold',
                        fontSize: '16px'
                    }}>
                        {deadlineStatus.message}
                    </div>
                )}
                
                <p className={`submitEntryButton ${!deadlineStatus.isOpen ? 'disabled' : ''}`}
                    onClick={handleSubmitClick}
                    style={{
                        backgroundColor: !deadlineStatus.isOpen ? '#ccc' : '',
                        cursor: !deadlineStatus.isOpen ? 'not-allowed' : 'pointer',
                        opacity: !deadlineStatus.isOpen ? 0.6 : 1
                    }}
                >{!deadlineStatus.isOpen ? 'Submissions Closed' : 'Submit Your Entry'}</p>
                <div className='youtubeVideoSection'>
                    <iframe className='youtubeVideo' src="https://www.youtube.com/embed/02SA_ViqkYo?si=aJZ5lCuTiUgAVd25" title="YouTube video player"
                        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>

        </div>
    )
}
